import actions from 'actions';

/**
 * Habitations' reducer initial state.
 * @type {Object}
 */
export const initialState = {
    address: null,
    match: null,
    list: null,
};

/**
 * Find habitations that match given address.
 * @param  {Array} habitations List of habitations
 * @param  {Object} address    Address from user
 * @return {Array}             List of matching habitations
 */
function getMatchingHabitations(habitations, address) {
    if (!habitations || habitations.length === 0 || !address) {
        return null;
    }

    return habitations.filter(
        (habitation) =>
            habitation.address &&
            String(habitation.address.name).toLowerCase() === String(address.name).toLowerCase() &&
            habitation.city &&
            String(habitation.city.name).toLowerCase() === String(address.city).toLowerCase() &&
            String(habitation.city.zip).toLowerCase() === String(address.zip).toLowerCase(),
    );
}

/**
 * Habitations's reducer.
 * @param {String} state  Existing Habitations's state
 * @param {Object} action Action dispatched
 * @return {Object} New state
 */
export default (state = initialState, action) => {
    let address;

    switch (action.type) {
        case actions.RECEIVED_GET_HABITATIONS:
            return {
                ...state,
                match: getMatchingHabitations(action.habitations, state.address),
                list: action.habitations,
            };
        case actions.UPDATE_SELECTED_ADDRESS:
            address = {
                name: String(action.addressName).toLowerCase(),
                city: action.cityName,
                zip: action.zip,
            };

            return {
                ...state,
                address,
                match: getMatchingHabitations(state.list, address),
            };
        case actions.FAILED_GET_HABITATIONS:
            return initialState;
        default:
            return state;
    }
};
